<template>
    <div ref="inputScan" class="c-input-scan">
        <b-card :class="{ 'bg-success': Core.Scan.ready === true, 'bg-warning' : Core.Scan.ready === false}" class="text-center">
            <blockquote class="card-blockquote">
                <div v-if="Core.Scan.ready">
                    <Spinner spinner="pulse"></Spinner>
                    <p v-if="Core.Scan.lastCode !== ''">{{Core.Text.format(Core.Definition.getDefinition('Dernière entrée: {0}'), Core.Scan.lastCode)}}</p>
                </div>
                <div v-else>
                    <span v-if="!Core.Scan.ready" class="h1"><i class="ml-2 fa fa-exclamation-triangle"></i></span>
                </div>
            </blockquote>
        </b-card>
    </div>
</template>

<script>
    import Spinner from './Spinner'
  export default {
      name: 'InputScan',
      components: {
          Spinner
      },
      props: {
          value: {
              type: String,
              default: ''
          },
          prefix: {
              type: String,
              default: 'PP'
          },
          suffix: {
              type: String,
              default: 'PP'
          },
          id: {
              type: String,
              default: ''
          },
          label: {
              type: String,
              default: ''
          },
          placeholder: {
              type: String,
              default: ''
          },
          description: {
              type: String,
              default: ''
          },
          labelCols: {
              type: Number,
              default: 0
          },
          autocomplete: {
              type: String,
              default: ''
          },
          readOnly: {
              type: Boolean,
              default: false
          },
          invalidFeedbackMessage: {
              type: String,
              default: ''
          },
          form: {
              type: Object,
              default: function () {
                  return {}
              }
          }
      },
      watch: {
          'Core.Scan.lastCode': {
              handler(val) {
                  this.$emit('input', val)
              }
          },
          value(val) {
              this.dataValue = val
          },
          dataValue(val) {
              this.$emit('input', val)
          },
      },
      mounted() {
          this.dataValue = this.value
      },
      data: () => {
          return {
              Core: window.Core,
              dataValue: ''
          }
      },
      methods: {
          chkState(val) {
              if (this.form !== undefined && this.form[val] !== undefined) {
                  const field = this.form[val]
                  return !field.$dirty || !field.$invalid
              }
          }
      }
  }
</script>